import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/index.css";
import { Button } from "react-bootstrap";
import AffiTabs from "./AffiTabs";
import { useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { FaWpforms } from "react-icons/fa";
import { BiMenuAltLeft } from "react-icons/bi";
import { Modal } from "react-bootstrap";
import ChangePassword from "./ChangePassword";
import Commonheader from "./CommonUtils/Commonheader";



function Footer() {
    return (
        <div className="footer-brand-logo">
            <p>Design and Developed by</p>
            <img src="../images/apcfss-logo-white.svg" className="img-fluid" alt="apcfss-logo-white" />
        </div>
    );
}


export default function RusaDashboard() {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 576);
    const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];
    const initialMenu =
        menuData
            .filter(item => item.role_id === 1 || item.role_id === 4)
            .sort((a, b) => a.order_by - b.order_by)[0]?.service_name || null;
    const [activeMenu, setActiveMenu] = useState(initialMenu);
    useEffect(() => {
        if (initialMenu) {
            navigate(`/${initialMenu}`, { replace: true });
        }
    }, []);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 990);


    const is_changedpassword = sessionStorage.getItem("is_changed");

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 990);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const [activeRusaTab, setActiveRusaTab] = useState("RUSA 1");

    const iconMap = {
        RusaDashboard: <MdDashboard size={20} />,
        RusaEntryForm: <FaWpforms size={20} />,
    };

    const [accessibleMenu, setAccessibleMenu] = useState(false);

    useEffect(() => {
        if (menuData?.length > 0) {
            const hasAccess = menuData.some(
                (item) => item?.role_id == 1 || item?.role_id == 4
            );
            setAccessibleMenu(hasAccess);
        }
    }, [menuData]);

    useEffect(() => {
        if (is_changedpassword === "false" || is_changedpassword === "null") {
            setModal(true);
        }
    }, []);


    const [modal, setModal] = useState("");

    // 🔴 CHANGE 2: auto-navigate to first menu
    useEffect(() => {
        if (!menuData || menuData.length === 0) return;

        const filteredMenu = menuData
            .filter(item => item.role_id === 1 || item.role_id === 4)
            .sort((a, b) => a.order_by - b.order_by);

        if (filteredMenu.length > 0) {
            setActiveMenu(filteredMenu[0].service_name);
            navigate(`/${filteredMenu[0].service_name}`, { replace: true });
        }
    }, [menuData, navigate]);

    console.log("accessibleMenu", accessibleMenu)
    return (
        <>
            <Modal
                show={modal}
                onHide={() => setModal(false)}
                size="xl"
                centered
                backdrop="static"
                keyboard={false}
                animation={false}
            >
                <Modal.Header
                    closeButton={false}
                    style={{
                        backgroundColor: "rgba(236, 148, 48, 1)",
                        fontSize: "19px",
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        color: "white",
                    }}
                >
                    Change Password
                </Modal.Header>
                <Modal.Body>
                    <ChangePassword />
                </Modal.Body>
            </Modal>

            {accessibleMenu === true ? (
                <>
                    <div className="dashboard-container second-dash">
                        <Commonheader />


                        <div className="main-area1">
                            <aside
                                className={`sidebar ${sidebarOpen ? "open" : "closed"}`}
                            >
                                <Button
                                    className="toggle-btn"
                                    onClick={() => setSidebarOpen(!sidebarOpen)}
                                >
                                    {sidebarOpen ? (
                                        <img
                                            src="../images/toggle1.svg"
                                            className="img-fluid toggle1"
                                            alt="toggle1"
                                        />
                                    ) : (
                                        <img
                                            src="../images/toggle2.svg"
                                            className="img-fluid toggle2"
                                            alt="toggle2"
                                        />
                                    )}
                                </Button>
                                <ul className={`sidebar-menu ${sidebarOpen ? "open" : "closed"}`}>
                                    {menuData
                                        .filter(item => item?.role_id == 1 || item?.role_id == 4)
                                        .sort((a, b) => a.order_by - b.order_by)
                                        .map((item) => (


                                            <li
                                                key={item?.service_id}
                                                role="button"
                                                tabIndex={0}
                                                className={activeMenu === item?.service_name ? "active" : ""}
                                                onClick={() => {
                                                    setActiveMenu(item?.service_name);
                                                    navigate(`/${item?.service_name}`);
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        setActiveMenu(item?.service_name);
                                                        navigate(`/${item?.service_name}`);
                                                    }
                                                }}
                                            >
                                                <span className="menu-icon">
                                                    {iconMap[item?.service_name] || <BiMenuAltLeft size={20} />}
                                                </span>
                                                <span className="menu-text">{item?.display_name}</span>
                                            </li>

                                        ))}

                                </ul>

                            </aside>

                            <div className="second-content">

                            </div>

                        </div>
                        <div className="footer-brand-logo">
                            <p>Design and Developed by</p>
                            <a href="https://apcfss.in/" target="_blank"><img src="../images/apcfss-logo-white.svg" className="img-fluid" alt="apcfss-logo-white" /></a>
                        </div>
                        <Footer />
                    </div>
                </>) : (<>

                    <div className="dashboard-container">
                        <Commonheader />
                        <div className="main-area">
                            <main className="content-box">
                                <div className="inner-content">
                                    <AffiTabs selectedtab={activeRusaTab} />
                                </div>
                            </main>
                        </div>
                    </div>
                </>)}



        </>
    );
}
